module.exports = __webpack_public_path__ + "static/media/gm.50fe2799.svg";